import { render, staticRenderFns } from "./ClienteShow.vue?vue&type=template&id=c00e8822&"
import script from "./ClienteShow.vue?vue&type=script&lang=js&"
export * from "./ClienteShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports